module.exports = __webpack_public_path__ + "static/media/BM_Inventory.6910be55.svg";